module.exports = __webpack_public_path__ + "static/img/manual_zh_12.1bdc98d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_12.png
// module id = C5xv
// module chunks = 4